import { render, staticRenderFns } from "./alipay_pc.vue?vue&type=template&id=343505bd&scoped=true"
import script from "./alipay_pc.vue?vue&type=script&lang=js"
export * from "./alipay_pc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343505bd",
  null
  
)

export default component.exports